module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"confirm":"OK"}}')
  delete Component.options._Ctor
}
